import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-representativewise-districtly',
  // standalone: true,
  // imports: [],
  templateUrl: './representativewise-districtly.component.html',
  styleUrl: './representativewise-districtly.component.scss'
})
export class RepresentativewiseDistrictlyComponent implements OnInit {

  offrepwiseData;
  today = new Date();
  startDate = '';
  endDate = '';
  isLoading: boolean = false;
  subTypesName = [
    { name: 'वार्षिक', isVisible: false },
    { name: 'त्रैवार्षिक', isVisible: false },
    { name: 'पंचवार्षिक', isVisible: false },
  ];
  totalth = 0;
  finalData = [];
  off_rep_name;
  appliedFilters: any = {};

  constructor(
    public dialogref: MatDialogRef<RepresentativewiseDistrictlyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {

    this.isLoading = true;
    this.offrepwiseData = this.data['offrepwisedata'];
    this.off_rep_name = this.data['off_rep_name'];
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    // console.log(this.offrepwiseData);

	  this.appliedFilters = this.data['appliedFilters'] || {};

		console.log("Applied Filters:", this.appliedFilters);

    let data = this.uniqueData(this.offrepwiseData, (a) => a.subscription_type);

    for (let i = 0; i < Object.keys(data).length; i++) {
      let flag = false;
      for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
        if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
          this.subTypesName[j]['isVisible'] = true;
          flag = true;
          break;
        }
      }
      if (!flag) {
        this.subTypesName.push({
          name: data[i]['subscription_type'],
          isVisible: true,
        });
        // }
      }
    }

    // console.log(this.subTypesName);
    // this.totalth = this.subTypesName.length * 5 + 8;
    this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 8;

    // this.getoffdata();
    this.setData();

    throw new Error('Method not implemented.');
  }


   countryNameNew: any
  stateNameNew: any
  //Old Method 
//   setData() {
//     let finalTotal = {};

//     this.subTypesName.forEach((b: any, i) => {
//         if (b.isVisible) {
//             let name = this.getKey(b.name);
//             finalTotal[name + '_एकूण'] = 0;
//             finalTotal[name + '_नवीन'] = 0;
//             finalTotal[name + '_नूतनीकरण'] = 0;
//             finalTotal[name + '_नूतनीकरणबाकी'] = 0;
//             if (i === 0) {
//                 finalTotal['name'] = 'एकूण';
//                 finalTotal['sub'] = 0;
//                 finalTotal['एकूण'] = 0;
//                 finalTotal['नवीन'] = 0;
//                 finalTotal['नूतनीकरण'] = 0;
//                 finalTotal['नूतनीकरणबाकी'] = 0;
//             }
//         }
//     });

//     let uniqueRepwiseData = this.uniqueData(this.offrepwiseData, (a) => a.rep_name);

//     uniqueRepwiseData.forEach((repDataItem: any) => {
//         let repwiseData = this.offrepwiseData.filter((a) => a.rep_name === repDataItem.rep_name);
//         let totalData = {};

//         this.subTypesName.forEach((b: any, i) => {
//             if (b.isVisible) {
//                 let name = this.getKey(b.name);
//                 totalData[name + '_एकूण'] = 0;
//                 totalData[name + '_नवीन'] = 0;
//                 totalData[name + '_नूतनीकरण'] = 0;
//                 totalData[name + '_नूतनीकरणबाकी'] = 0;
//                 if (i === 0) {
//                     totalData['sub'] = 0;
//                     totalData['एकूण'] = 0;
//                     totalData['नवीन'] = 0;
//                     totalData['नूतनीकरण'] = 0;
//                     totalData['नूतनीकरणबाकी'] = 0;
//                 }
//             }
//         });

//         repwiseData.forEach((a: any, i) => {
//             if (i === 0) {
//                 totalData['rep_name'] = a.rep_name;
//                 totalData['office_rep_name'] = a.office_rep_name;
//                 totalData['rep_taluka'] = a.rep_taluka;
//             }

//             let name = this.getKey(a.subscription_type);
//             let today = new Date();
//             today.setMonth(today.getMonth() + 1);

//             if (a['sub_perid_to_date'] > formatDate(new Date(today), 'yyyy-MM-dd', 'en-IN', 'GMT+0530')) {
//                 totalData[name + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//                 finalTotal[name + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;

//                 totalData[name + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//                 finalTotal[name + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

//                 totalData['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//                 finalTotal['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;

//                 totalData['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//                 finalTotal['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

//                 totalData['sub'] += 1;
//                 finalTotal['sub'] += 1;

//                 totalData[name + '_एकूण'] += parseInt(a.total_amt);
//                 finalTotal[name + '_एकूण'] += parseInt(a.total_amt);

//                 totalData['एकूण'] += parseInt(a.total_amt);
//                 finalTotal['एकूण'] += parseInt(a.total_amt);
//             } else {
//                 totalData[name + '_नूतनीकरणबाकी'] += 1;
//                 finalTotal[name + '_नूतनीकरणबाकी'] += 1;

//                 totalData['नूतनीकरणबाकी'] += 1;
//                 finalTotal['नूतनीकरणबाकी'] += 1;
//             }
//         });

//         this.finalData.push(totalData);
//     });

//     this.finalData.push(finalTotal);
//     console.log(this.finalData);

//     this.isLoading = false;
// }

//Correct Code 
// setData() {
//   this.finalData = [];
//   let finalTotal: any = {};

//   // Initialize final total
//   this.subTypesName.forEach((b: any, i) => {
//     if (b.isVisible) {
//       let name = this.getKey(b.name);
//       finalTotal[name + '_एकूण'] = 0;
//       finalTotal[name + '_नवीन'] = 0;
//       finalTotal[name + '_नूतनीकरण'] = 0;
//       finalTotal[name + '_नूतनीकरणबाकी'] = 0;
//       if (i === 0) {
//         finalTotal['name'] = 'एकूण';
//         finalTotal['sub'] = 0;
//         finalTotal['एकूण'] = 0;
//         finalTotal['नवीन'] = 0;
//         finalTotal['नूतनीकरण'] = 0;
//         finalTotal['नूतनीकरणबाकी'] = 0;
//       }
//     }
//   });

//   const repGroups = this.groupBy(this.offrepwiseData, 'rep_name');

//   Object.keys(repGroups).forEach(repName => {
//     const repData = repGroups[repName];
//     const districtGroups = this.groupBy(repData, 'rep_taluka');

//     let repTotal: any = {};

//     // Initialize representative total
//     this.subTypesName.forEach((b: any, i) => {
//       if (b.isVisible) {
//         let name = this.getKey(b.name);
//         repTotal[name + '_एकूण'] = 0;
//         repTotal[name + '_नवीन'] = 0;
//         repTotal[name + '_नूतनीकरण'] = 0;
//         repTotal[name + '_नूतनीकरणबाकी'] = 0;
//         if (i === 0) {
//           repTotal['name'] = 'प्रतिनिधी एकूण - ' + repName;
//           repTotal['sub'] = 0;
//           repTotal['एकूण'] = 0;
//           repTotal['नवीन'] = 0;
//           repTotal['नूतनीकरण'] = 0;
//           repTotal['नूतनीकरणबाकी'] = 0;
//         }
//       }
//     });

//     Object.keys(districtGroups).forEach(district => {
//       const districtData = districtGroups[district];
//       let totalData: any = {};

//       // Initialize district total
//       this.subTypesName.forEach((b: any, i) => {
//         if (b.isVisible) {
//           let name = this.getKey(b.name);
//           totalData[name + '_एकूण'] = 0;
//           totalData[name + '_नवीन'] = 0;
//           totalData[name + '_नूतनीकरण'] = 0;
//           totalData[name + '_नूतनीकरणबाकी'] = 0;
//           if (i === 0) {
//             totalData['sub'] = 0;
//             totalData['एकूण'] = 0;
//             totalData['नवीन'] = 0;
//             totalData['नूतनीकरण'] = 0;
//             totalData['नूतनीकरणबाकी'] = 0;
//           }
//         }
//       });

//       districtData.forEach((a: any, i) => {
//         if (i === 0) {
//           totalData['rep_name'] = a.rep_name;
//           totalData['office_rep_name'] = a.office_rep_name;
//           totalData['rep_taluka'] = a.rep_taluka;
//           totalData['district_name'] = a.district_name;
//           totalData['taluka'] = a.taluka;
//         }

//         let name = this.getKey(a.subscription_type);
//         let today = new Date();
//         today.setMonth(today.getMonth() + 1);
//         let cutoffDate = formatDate(new Date(today), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');

//         if (a['sub_perid_to_date'] > cutoffDate) {
//           totalData[name + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//           repTotal[name + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//           finalTotal[name + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;

//           totalData[name + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//           repTotal[name + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//           finalTotal[name + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

//           totalData['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//           repTotal['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//           finalTotal['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;

//           totalData['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//           repTotal['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//           finalTotal['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

//           totalData['sub'] += 1;
//           repTotal['sub'] += 1;
//           finalTotal['sub'] += 1;

//           totalData[name + '_एकूण'] += parseInt(a.total_amt);
//           repTotal[name + '_एकूण'] += parseInt(a.total_amt);
//           finalTotal[name + '_एकूण'] += parseInt(a.total_amt);

//           totalData['एकूण'] += parseInt(a.total_amt);
//           repTotal['एकूण'] += parseInt(a.total_amt);
//           finalTotal['एकूण'] += parseInt(a.total_amt);
//         } else {
//           totalData[name + '_नूतनीकरणबाकी'] += 1;
//           repTotal[name + '_नूतनीकरणबाकी'] += 1;
//           finalTotal[name + '_नूतनीकरणबाकी'] += 1;

//           totalData['नूतनीकरणबाकी'] += 1;
//           repTotal['नूतनीकरणबाकी'] += 1;
//           finalTotal['नूतनीकरणबाकी'] += 1;
//         }
//       });

//       if (districtData.length > 0) {
//         this.countryNameNew = districtData[0].country;
//         this.stateNameNew = districtData[0].state;
//       }

//       this.finalData.push(totalData);

//       // Push total row for this district under the representative
//       let districtTotalRow = { ...totalData };
//       districtTotalRow.name = 'एकूण - ' + district;
//       this.finalData.push(districtTotalRow);
//     });

//     // After all districts under representative, push representative total
//     this.finalData.push(repTotal);
//   });

//   // Finally push grand total
//   this.finalData.push(finalTotal);
//   this.isLoading = false;
// }


// Correct Method show नूतनी-बाकी Calculation 
// setData() {
//   this.finalData = [];
//   let finalTotal: any = {};

//   // Initialize grand total
//   this.subTypesName.forEach((b: any, i) => {
//     if (b.isVisible) {
//       let name = this.getKey(b.name);
//       finalTotal[name + '_एकूण'] = 0;
//       finalTotal[name + '_नवीन'] = 0;
//       finalTotal[name + '_नूतनीकरण'] = 0;
//       finalTotal[name + '_नूतनीकरणबाकी'] = 0;
//       if (i === 0) {
//         finalTotal['name'] = 'एकूण';
//         finalTotal['sub'] = 0;
//         finalTotal['एकूण'] = 0;
//         finalTotal['नवीन'] = 0;
//         finalTotal['नूतनीकरण'] = 0;
//         finalTotal['नूतनीकरणबाकी'] = 0;
//       }
//     }
//   });

//   const repGroups = this.groupBy(this.offrepwiseData, 'rep_name');

//   Object.keys(repGroups).forEach(repName => {
//     const repData = repGroups[repName];
//     const districtGroups = this.groupBy(repData, 'district_name');

//     let repTotal: any = {};

//     // Initialize rep total
//     this.subTypesName.forEach((b: any, i) => {
//       if (b.isVisible) {
//         let name = this.getKey(b.name);
//         repTotal[name + '_एकूण'] = 0;
//         repTotal[name + '_नवीन'] = 0;
//         repTotal[name + '_नूतनीकरण'] = 0;
//         repTotal[name + '_नूतनीकरणबाकी'] = 0;
//         if (i === 0) {
//           repTotal['name'] = 'प्रतिनिधी एकूण - ' + repName;
//           repTotal['sub'] = 0;
//           repTotal['एकूण'] = 0;
//           repTotal['नवीन'] = 0;
//           repTotal['नूतनीकरण'] = 0;
//           repTotal['नूतनीकरणबाकी'] = 0;
//         }
//       }
//     });

//     let repShown = false;

//     Object.keys(districtGroups).forEach(district => {
//       const districtData = districtGroups[district];
//       let districtTotal: any = {};

//       // Initialize district total
//       this.subTypesName.forEach((b: any, i) => {
//         if (b.isVisible) {
//           let name = this.getKey(b.name);
//           districtTotal[name + '_एकूण'] = 0;
//           districtTotal[name + '_नवीन'] = 0;
//           districtTotal[name + '_नूतनीकरण'] = 0;
//           districtTotal[name + '_नूतनीकरणबाकी'] = 0;
//           if (i === 0) {
//             districtTotal['rep_name'] = repName;
//             districtTotal['rep_taluka'] = districtData[0].rep_taluka;
//             districtTotal['district_name'] = district;
//             districtTotal['sub'] = 0;
//             districtTotal['एकूण'] = 0;
//             districtTotal['नवीन'] = 0;
//             districtTotal['नूतनीकरण'] = 0;
//             districtTotal['नूतनीकरणबाकी'] = 0;
//           }
//         }
//       });

//       districtData.forEach((a: any) => {
//         let name = this.getKey(a.subscription_type);
//         let today = new Date();
//         today.setMonth(today.getMonth() + 1);
//         let cutoffDate = formatDate(today, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');

//         if (a['sub_perid_to_date'] > cutoffDate) {
//           if (a.rcpt_type === 'New') {
//             districtTotal[name + '_नवीन']++;
//             repTotal[name + '_नवीन']++;
//             finalTotal[name + '_नवीन']++;
//             districtTotal['नवीन']++;
//             repTotal['नवीन']++;
//             finalTotal['नवीन']++;
//           }
//           if (a.rcpt_type === 'Renew') {
//             districtTotal[name + '_नूतनीकरण']++;
//             repTotal[name + '_नूतनीकरण']++;
//             finalTotal[name + '_नूतनीकरण']++;
//             districtTotal['नूतनीकरण']++;
//             repTotal['नूतनीकरण']++;
//             finalTotal['नूतनीकरण']++;
//           }

//           districtTotal['sub']++;
//           repTotal['sub']++;
//           finalTotal['sub']++;

//           const amt = parseInt(a.total_amt) || 0;
//           districtTotal[name + '_एकूण'] += amt;
//           repTotal[name + '_एकूण'] += amt;
//           finalTotal[name + '_एकूण'] += amt;
//           districtTotal['एकूण'] += amt;
//           repTotal['एकूण'] += amt;
//           finalTotal['एकूण'] += amt;
//         } else {
//           districtTotal[name + '_नूतनीकरणबाकी']++;
//           repTotal[name + '_नूतनीकरणबाकी']++;
//           finalTotal[name + '_नूतनीकरणबाकी']++;
//           districtTotal['नूतनीकरणबाकी']++;
//           repTotal['नूतनीकरणबाकी']++;
//           finalTotal['नूतनीकरणबाकी']++;
//         }
//       });

//       districtTotal['showRepName'] = !repShown;
//       repShown = true;

//       this.finalData.push({ ...districtTotal, type: 'record' });
//     });

//     // Push representative total
//     repTotal.type = 'repTotal';
//     this.finalData.push(repTotal);
//   });

//   // Push grand total
//   finalTotal.type = 'grandTotal';
//   this.finalData.push(finalTotal);
//   this.isLoading = false;
// }

// Remove नूतनी-बाकी Calculation  
// setData() {
//   this.finalData = [];
//   let finalTotal: any = {};

//   this.subTypesName.forEach((b: any, i) => {
//     if (b.isVisible) {
//       let name = this.getKey(b.name);
//       finalTotal[name + '_एकूण'] = 0;
//       finalTotal[name + '_नवीन'] = 0;
//       finalTotal[name + '_नूतनीकरण'] = 0;
//       finalTotal[name + '_नूतनीकरणबाकी'] = 0;
//       if (i === 0) {
//         finalTotal['name'] = 'एकूण';
//         finalTotal['sub'] = 0;
//         finalTotal['एकूण'] = 0;
//         finalTotal['नवीन'] = 0;
//         finalTotal['नूतनीकरण'] = 0;
//         finalTotal['नूतनीकरणबाकी'] = 0;
//       }
//     }
//   });

//   const repGroups = this.groupBy(this.offrepwiseData, 'rep_name');

//   Object.keys(repGroups).forEach(repName => {
//     const repData = repGroups[repName];
//     const districtGroups = this.groupBy(repData, 'district_name');

//     let repTotal: any = {};

//     this.subTypesName.forEach((b: any, i) => {
//       if (b.isVisible) {
//         let name = this.getKey(b.name);
//         repTotal[name + '_एकूण'] = 0;
//         repTotal[name + '_नवीन'] = 0;
//         repTotal[name + '_नूतनीकरण'] = 0;
//         repTotal[name + '_नूतनीकरणबाकी'] = 0;
//         if (i === 0) {
//           repTotal['name'] = 'प्रतिनिधी एकूण - ' + repName;
//           repTotal['sub'] = 0;
//           repTotal['एकूण'] = 0;
//           repTotal['नवीन'] = 0;
//           repTotal['नूतनीकरण'] = 0;
//           repTotal['नूतनीकरणबाकी'] = 0;
//         }
//       }
//     });

//     let repShown = false;

//     Object.keys(districtGroups).forEach(district => {
//       const districtData = districtGroups[district];
//       let districtTotal: any = {};

//       this.subTypesName.forEach((b: any, i) => {
//         if (b.isVisible) {
//           let name = this.getKey(b.name);
//           districtTotal[name + '_एकूण'] = 0;
//           districtTotal[name + '_नवीन'] = 0;
//           districtTotal[name + '_नूतनीकरण'] = 0;
//           districtTotal[name + '_नूतनीकरणबाकी'] = 0;
//           if (i === 0) {
//             districtTotal['rep_name'] = repName;
//             districtTotal['rep_taluka'] = districtData[0].rep_taluka;
//             districtTotal['district_name'] = district;
//             districtTotal['sub'] = 0;
//             districtTotal['एकूण'] = 0;
//             districtTotal['नवीन'] = 0;
//             districtTotal['नूतनीकरण'] = 0;
//             districtTotal['नूतनीकरणबाकी'] = 0;
//           }
//         }
//       });

//       districtData.forEach((a: any) => {
//         let name = this.getKey(a.subscription_type);
//         let today = new Date();
//         today.setMonth(today.getMonth() + 1);
//         let cutoffDate = formatDate(today, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');

//         // ✅ COUNT EVERY SUBSCRIBER (including renewal pending)
//         districtTotal['sub']++;
//         repTotal['sub']++;
//         finalTotal['sub']++;

//         if (a['sub_perid_to_date'] > cutoffDate) {
//           if (a.rcpt_type === 'New') {
//             districtTotal[name + '_नवीन']++;
//             repTotal[name + '_नवीन']++;
//             finalTotal[name + '_नवीन']++;
//             districtTotal['नवीन']++;
//             repTotal['नवीन']++;
//             finalTotal['नवीन']++;
//           }
//           if (a.rcpt_type === 'Renew') {
//             districtTotal[name + '_नूतनीकरण']++;
//             repTotal[name + '_नूतनीकरण']++;
//             finalTotal[name + '_नूतनीकरण']++;
//             districtTotal['नूतनीकरण']++;
//             repTotal['नूतनीकरण']++;
//             finalTotal['नूतनीकरण']++;
//           }

//           const amt = parseInt(a.total_amt) || 0;
//           districtTotal[name + '_एकूण'] += amt;
//           repTotal[name + '_एकूण'] += amt;
//           finalTotal[name + '_एकूण'] += amt;
//           districtTotal['एकूण'] += amt;
//           repTotal['एकूण'] += amt;
//           finalTotal['एकूण'] += amt;
//         } else {
//           districtTotal[name + '_नूतनीकरणबाकी']++;
//           repTotal[name + '_नूतनीकरणबाकी']++;
//           finalTotal[name + '_नूतनीकरणबाकी']++;
//           districtTotal['नूतनीकरणबाकी']++;
//           repTotal['नूतनीकरणबाकी']++;
//           finalTotal['नूतनीकरणबाकी']++;
//         }
//       });

//       districtTotal['showRepName'] = !repShown;
//       repShown = true;

//       this.finalData.push({ ...districtTotal, type: 'record' });
//     });

//     repTotal.type = 'repTotal';
//     this.finalData.push(repTotal);
//   });

//   finalTotal.type = 'grandTotal';
//   this.finalData.push(finalTotal);
//   this.isLoading = false;
// }



// Helper method: group array by key
groupBy(arr: any[], key: string) {
    return arr.reduce((acc, curr) => {
        (acc[curr[key]] = acc[curr[key]] || []).push(curr);
        return acc;
    }, {});
}

// setData() {

//   this.finalData = [];

//   let finalTotal: any = {};

//   this.subTypesName.forEach((b: any, i) => {
//     if (b.isVisible) {

//       let name = this.getKey(b.name);

//       finalTotal[name + '_एकूण'] = 0;
//       finalTotal[name + '_नवीन'] = 0;
//       finalTotal[name + '_नूतनीकरण'] = 0;
//       finalTotal[name + '_नूतनीकरणबाकी'] = 0;

//       if (i === 0) {
//         finalTotal['name'] = 'एकूण';
//         finalTotal['sub'] = 0;

//         // ✅ TOTAL AMOUNT
//         finalTotal['एकूण'] = 0;

//         // ✅ TOTAL COUNT
//         finalTotal['नवीन'] = 0;
//         finalTotal['नूतनीकरण'] = 0;
//         finalTotal['नूतनीकरणबाकी'] = 0;
//       }
//     }
//   });

//   const repGroups = this.groupBy(this.offrepwiseData, 'rep_name');

//   Object.keys(repGroups).forEach(repName => {

//     const repData = repGroups[repName];

//     const districtGroups = this.groupBy(repData, 'district_name');

//     let repTotal: any = {};

//     this.subTypesName.forEach((b: any, i) => {

//       if (b.isVisible) {

//         let name = this.getKey(b.name);

//         repTotal[name + '_एकूण'] = 0;
//         repTotal[name + '_नवीन'] = 0;
//         repTotal[name + '_नूतनीकरण'] = 0;
//         repTotal[name + '_नूतनीकरणबाकी'] = 0;

//         if (i === 0) {

//           repTotal['name'] = 'प्रतिनिधी एकूण - ' + repName;

//           repTotal['sub'] = 0;

//           // ✅ TOTAL AMOUNT
//           repTotal['एकूण'] = 0;

//           // ✅ TOTAL COUNT
//           repTotal['नवीन'] = 0;
//           repTotal['नूतनीकरण'] = 0;
//           repTotal['नूतनीकरणबाकी'] = 0;
//         }
//       }
//     });

//     let repShown = false;

//     Object.keys(districtGroups).forEach(district => {

//       const districtData = districtGroups[district];

//       let districtTotal: any = {};

//       this.subTypesName.forEach((b: any, i) => {

//         if (b.isVisible) {

//           let name = this.getKey(b.name);

//           districtTotal[name + '_एकूण'] = 0;
//           districtTotal[name + '_नवीन'] = 0;
//           districtTotal[name + '_नूतनीकरण'] = 0;
//           districtTotal[name + '_नूतनीकरणबाकी'] = 0;

//           if (i === 0) {

//             districtTotal['rep_name'] = repName;
//             districtTotal['rep_taluka'] = districtData[0].rep_taluka;
//             districtTotal['district_name'] = district;

//             districtTotal['sub'] = 0;

//             // ✅ TOTAL AMOUNT
//             districtTotal['एकूण'] = 0;

//             // ✅ TOTAL COUNT
//             districtTotal['नवीन'] = 0;
//             districtTotal['नूतनीकरण'] = 0;
//             districtTotal['नूतनीकरणबाकी'] = 0;
//           }
//         }
//       });

//       districtData.forEach((a: any) => {

//         let name = this.getKey(a.subscription_type);

//         let today = new Date();

//         today.setMonth(today.getMonth() + 1);

//         let cutoffDate = formatDate(
//           today,
//           'yyyy-MM-dd',
//           'en-IN',
//           'GMT+0530'
//         );

//         // ✅ COUNT EVERY SUBSCRIBER
//         districtTotal['sub']++;
//         repTotal['sub']++;
//         finalTotal['sub']++;

//         const amt = parseInt(a.total_amt) || 0;

//         // ✅ नवीन
//         if (a.rcpt_type === 'New') {

//           districtTotal[name + '_नवीन']++;
//           repTotal[name + '_नवीन']++;
//           finalTotal[name + '_नवीन']++;

//           districtTotal['नवीन']++;
//           repTotal['नवीन']++;
//           finalTotal['नवीन']++;
//         }

//         // ✅ नूतनीकरण
//         if (a.rcpt_type === 'Renew') {

//           districtTotal[name + '_नूतनीकरण']++;
//           repTotal[name + '_नूतनीकरण']++;
//           finalTotal[name + '_नूतनीकरण']++;

//           districtTotal['नूतनीकरण']++;
//           repTotal['नूतनीकरण']++;
//           finalTotal['नूतनीकरण']++;
//         }

//         // ✅ रक्कम ALWAYS ADD IN एकूण
//         districtTotal[name + '_एकूण'] += amt;
//         repTotal[name + '_एकूण'] += amt;
//         finalTotal[name + '_एकूण'] += amt;

//         districtTotal['एकूण'] += amt;
//         repTotal['एकूण'] += amt;
//         finalTotal['एकूण'] += amt;

//         // ✅ ONLY PENDING COUNT
//         if (a['sub_perid_to_date'] <= cutoffDate) {

//           districtTotal[name + '_नूतनीकरणबाकी']++;
//           repTotal[name + '_नूतनीकरणबाकी']++;
//           finalTotal[name + '_नूतनीकरणबाकी']++;

//           districtTotal['नूतनीकरणबाकी']++;
//           repTotal['नूतनीकरणबाकी']++;
//           finalTotal['नूतनीकरणबाकी']++;
//         }

//       });

//       districtTotal['showRepName'] = !repShown;

//       repShown = true;

//       this.finalData.push({
//         ...districtTotal,
//         type: 'record'
//       });

//     });

//     repTotal.type = 'repTotal';

//     this.finalData.push(repTotal);

//   });

//   finalTotal.type = 'grandTotal';

//   this.finalData.push(finalTotal);

//   this.isLoading = false;
// }


  getKey(name) {
    return name.replaceAll(' ', '_');
  }

  setData() {

  this.finalData = [];

  let finalTotal: any = {};

  this.subTypesName.forEach((b: any, i) => {
    if (b.isVisible) {

      let name = this.getKey(b.name);

      finalTotal[name + '_एकूण'] = 0;
      finalTotal[name + '_नवीन'] = 0;
      finalTotal[name + '_नूतनीकरण'] = 0;
      finalTotal[name + '_नूतनीकरणबाकी'] = 0;

      if (i === 0) {
        finalTotal['name'] = 'एकूण';
        finalTotal['sub'] = 0;

        // ✅ TOTAL AMOUNT
        finalTotal['एकूण'] = 0;

        // ✅ TOTAL COUNT
        finalTotal['नवीन'] = 0;
        finalTotal['नूतनीकरण'] = 0;
        finalTotal['नूतनीकरणबाकी'] = 0;
      }
    }
  });

  const repGroups = this.groupBy(this.offrepwiseData, 'rep_name');

  Object.keys(repGroups).forEach(repName => {

    const repData = repGroups[repName];

    const districtGroups = this.groupBy(repData, 'district_name');

    let repTotal: any = {};

    this.subTypesName.forEach((b: any, i) => {

      if (b.isVisible) {

        let name = this.getKey(b.name);

        repTotal[name + '_एकूण'] = 0;
        repTotal[name + '_नवीन'] = 0;
        repTotal[name + '_नूतनीकरण'] = 0;
        repTotal[name + '_नूतनीकरणबाकी'] = 0;

        if (i === 0) {

          repTotal['name'] = 'प्रतिनिधी एकूण - ' + repName;

          repTotal['sub'] = 0;

          // ✅ TOTAL AMOUNT
          repTotal['एकूण'] = 0;

          // ✅ TOTAL COUNT
          repTotal['नवीन'] = 0;
          repTotal['नूतनीकरण'] = 0;
          repTotal['नूतनीकरणबाकी'] = 0;
        }
      }
    });

    let repShown = false;

    Object.keys(districtGroups).forEach(district => {

      const districtData = districtGroups[district];

      let districtTotal: any = {};

      this.subTypesName.forEach((b: any, i) => {

        if (b.isVisible) {

          let name = this.getKey(b.name);

          districtTotal[name + '_एकूण'] = 0;
          districtTotal[name + '_नवीन'] = 0;
          districtTotal[name + '_नूतनीकरण'] = 0;
          districtTotal[name + '_नूतनीकरणबाकी'] = 0;

          if (i === 0) {

            districtTotal['rep_name'] = repName;
            districtTotal['rep_taluka'] = districtData[0].rep_taluka;
            districtTotal['district_name'] = district;

            districtTotal['sub'] = 0;

            // ✅ TOTAL AMOUNT
            districtTotal['एकूण'] = 0;

            // ✅ TOTAL COUNT
            districtTotal['नवीन'] = 0;
            districtTotal['नूतनीकरण'] = 0;
            districtTotal['नूतनीकरणबाकी'] = 0;
          }
        }
      });

      districtData.forEach((a: any) => {

        let name = this.getKey(a.subscription_type);

        let today = new Date();

        today.setMonth(today.getMonth() + 1);

        let cutoffDate = formatDate(
          today,
          'yyyy-MM-dd',
          'en-IN',
          'GMT+0530'
        );

        // ✅ COUNT EVERY SUBSCRIBER
        districtTotal['sub']++;
        repTotal['sub']++;
        finalTotal['sub']++;

        // ✅ FIX AMOUNT
        const amt = Number(a.total_amt) || 0;

        // ✅ नवीन
        if (a.rcpt_type === 'New') {

          districtTotal[name + '_नवीन'] =
            (districtTotal[name + '_नवीन'] || 0) + 1;

          repTotal[name + '_नवीन'] =
            (repTotal[name + '_नवीन'] || 0) + 1;

          finalTotal[name + '_नवीन'] =
            (finalTotal[name + '_नवीन'] || 0) + 1;

          districtTotal['नवीन']++;
          repTotal['नवीन']++;
          finalTotal['नवीन']++;
        }

        // ✅ नूतनीकरण
        if (a.rcpt_type === 'Renew') {

          districtTotal[name + '_नूतनीकरण'] =
            (districtTotal[name + '_नूतनीकरण'] || 0) + 1;

          repTotal[name + '_नूतनीकरण'] =
            (repTotal[name + '_नूतनीकरण'] || 0) + 1;

          finalTotal[name + '_नूतनीकरण'] =
            (finalTotal[name + '_नूतनीकरण'] || 0) + 1;

          districtTotal['नूतनीकरण']++;
          repTotal['नूतनीकरण']++;
          finalTotal['नूतनीकरण']++;
        }

        // ✅ FIX:
        // amount always add correctly in subtype total
        districtTotal[name + '_एकूण'] =
          (districtTotal[name + '_एकूण'] || 0) + amt;

        repTotal[name + '_एकूण'] =
          (repTotal[name + '_एकूण'] || 0) + amt;

        finalTotal[name + '_एकूण'] =
          (finalTotal[name + '_एकूण'] || 0) + amt;

        // ✅ TOTAL रक्कम
        districtTotal['एकूण'] =
          (districtTotal['एकूण'] || 0) + amt;

        repTotal['एकूण'] =
          (repTotal['एकूण'] || 0) + amt;

        finalTotal['एकूण'] =
          (finalTotal['एकूण'] || 0) + amt;

        // ✅ ONLY PENDING COUNT
        if (a['sub_perid_to_date'] <= cutoffDate) {

          districtTotal[name + '_नूतनीकरणबाकी'] =
            (districtTotal[name + '_नूतनीकरणबाकी'] || 0) + 1;

          repTotal[name + '_नूतनीकरणबाकी'] =
            (repTotal[name + '_नूतनीकरणबाकी'] || 0) + 1;

          finalTotal[name + '_नूतनीकरणबाकी'] =
            (finalTotal[name + '_नूतनीकरणबाकी'] || 0) + 1;

          districtTotal['नूतनीकरणबाकी']++;
          repTotal['नूतनीकरणबाकी']++;
          finalTotal['नूतनीकरणबाकी']++;
        }

      });

      districtTotal['showRepName'] = !repShown;

      repShown = true;

      this.finalData.push({
        ...districtTotal,
        type: 'record'
      });

    });

    repTotal.type = 'repTotal';

    this.finalData.push(repTotal);

  });

  finalTotal.type = 'grandTotal';

  this.finalData.push(finalTotal);

  this.isLoading = false;
}

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }


 exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }


   //Main Report Method Use in all Printing Page
  show = false
  printPage() {
    this.show = true
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
      console.error("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
             <html>
                 <head>
                     <title>Print Report</title>
                     <style>
                         @media print {
                             @page { 
                                 size: A3 landscape; /* Set A3 size with landscape mode */
                                 margin: 5mm; /* Adjust margins */
                             }
                             body { 
                                 font-family: Arial, sans-serif; 
                                 font-size: 15px; /* Adjust font size */
                                 margin: 0; 
                                 padding: 5mm; 
                                 line-height: 1.2; 
                             }
                             table { 
                                 width: 100%; 
                                 height: auto !important;
                                 border-collapse: collapse; 
                                 table-layout: fixed; /* Prevent column expansion */
                                 page-break-inside: avoid; /* Avoid breaking the table */
                             }
                             th, td { 
                                 padding: 2px; 
                                 border: 1px solid black; 
                                 text-align: center; 
                                 font-size: 16px; /* Adjusted font size */
                                 line-height: 1.2; 
                             }
                             .noPrint { 
                                 display: none; /* Hide print button */
                             }
                         }
                     </style>
                 </head>
                 <body>
                     <div id="print-section">
                         ${printContent}
                     </div>
                     <script>
                         window.onload = function() { 
                             window.print(); 
                             setTimeout(() => { window.close(); }, 500);
                         };
                     </script>
                 </body>
             </html>
         `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }




}
